export let i18nMap: Record<string, Record<string, string>> = {};

export function setI18nMap(map: Record<string, Record<string, string>>) {
  i18nMap = map;
}
